"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./UserIcon.css");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var UserIcon = /*#__PURE__*/function (_React$Component) {
  _inherits(UserIcon, _React$Component);

  var _super = _createSuper(UserIcon);

  function UserIcon() {
    _classCallCheck(this, UserIcon);

    return _super.apply(this, arguments);
  }

  _createClass(UserIcon, [{
    key: "getEmployerIcon",
    value: function getEmployerIcon(user) {
      var employerIcon = null;

      if (user) {
        if (user.employerThumbnail) {
          employerIcon = /*#__PURE__*/_react.default.createElement("div", {
            className: "small-thumbnail-overlay employer-thumbnail-overlay small-outlined-thumbnail-overlay"
          }, /*#__PURE__*/_react.default.createElement("img", {
            role: "presentation",
            src: user.employerThumbnail,
            alt: "Employer logo"
          }));
        }
      }

      return employerIcon;
    }
  }, {
    key: "getMemberIcon",
    value: function getMemberIcon(member, isImpersonating) {
      var memberIcon = null;

      if (isImpersonating) {
        memberIcon = /*#__PURE__*/_react.default.createElement("div", {
          className: "outlined-thumbnail-overlay"
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "impersonating-thumb thumb"
        }, /*#__PURE__*/_react.default.createElement("i", {
          className: "icon-eye"
        })));
      } else if (member) {
        if (member.firstName && member.lastName) {
          var initials = member.firstName.substring(0, 1) + member.lastName.substring(0, 1);
          memberIcon = /*#__PURE__*/_react.default.createElement("div", {
            className: "outlined-thumbnail-overlay"
          }, /*#__PURE__*/_react.default.createElement("span", {
            className: "initials-thumb thumb"
          }, initials));
        }
      } else {
        memberIcon = /*#__PURE__*/_react.default.createElement("div", {
          className: "thumbnail-overlay"
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "default-thumb thumb"
        }));
      }

      return memberIcon;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isImpersonating = _this$props.isImpersonating,
          user = _this$props.user,
          isSales = _this$props.isSales,
          isEmployer = _this$props.isEmployer;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "user-icon-container"
      }, isEmployer && this.getEmployerIcon(user), isSales && /*#__PURE__*/_react.default.createElement("div", {
        className: "small-thumbnail-overlay sales-thumbnail-overlay"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon-dollar"
      })), this.getMemberIcon(user, isImpersonating));
    }
  }]);

  return UserIcon;
}(_react.default.Component);

exports.default = UserIcon;

_defineProperty(UserIcon, "propTypes", {
  user: _propTypes.default.object.isRequired,
  isImpersonating: _propTypes.default.bool,
  isSales: _propTypes.default.bool
});